const products = [
  {
    id: 'vpn',
    name: 'VPN Shield',
    tagline: 'Secure Connection',
    description:
      'A powerful VPN application for iOS that encrypts your internet traffic, masks your IP address, and keeps your online activity private. Designed for speed and reliability across all networks.',
    highlights: ['Military-grade AES-256 encryption', 'Zero-log policy', 'Global server network', 'One-tap connect'],
    image:
      'https://public.readdy.ai/ai/img_res/83e724cec15e5970399c62f4b9fa6b43.jpg',
    accent: 'from-emerald-500/10 to-teal-500/10',
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
    icon: 'ri-shield-keyhole-line',
  },
  {
    id: 'cleaner',
    name: 'Smart Cleaner',
    tagline: 'Device Optimization',
    description:
      'An intelligent iOS cleaner that removes junk files, duplicate photos, and unnecessary data to free up storage space and boost your device performance — all with a single tap.',
    highlights: ['Deep junk file scan', 'Duplicate photo finder', 'Memory optimizer', 'Battery health insights'],
    image:
      'https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20concept%20art%2C%20abstract%20clean%20sweep%20visualization%20with%20sparkling%20particles%20and%20smooth%20gradients%2C%20light%20background%20with%20orange%20and%20amber%20accents%2C%20device%20optimization%20theme%2C%20minimalist%20modern%20design%2C%20no%20text%2C%20high%20resolution%20digital%20art&width=600&height=700&seq=cleaner001&orientation=portrait',
    accent: 'from-orange-500/10 to-amber-500/10',
    iconBg: 'bg-orange-50',
    iconColor: 'text-orange-500',
    icon: 'ri-sparkling-2-line',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full bg-gray-950 py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-24">
          <div>
            <div className="inline-flex items-center border border-white/20 rounded-full px-5 py-1.5 mb-8">
              <span className="text-xs font-semibold tracking-widest uppercase text-white/60" style={{ fontFamily: "'Inter', sans-serif" }}>
                Our Products
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              Premium Solutions
              <br />
              <span className="font-light text-white/40">for iOS Security &amp; Performance</span>
            </h2>
          </div>
          <p className="text-base text-white/50 max-w-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            Two flagship applications built from the ground up for the iOS ecosystem.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="group relative rounded-2xl overflow-hidden bg-gray-900 border border-white/5 hover:border-white/10 transition-all duration-500"
            >
              {/* Image */}
              <div className="relative w-full h-72 md:h-96 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className={`absolute inset-0 bg-gradient-to-b ${product.accent} opacity-60`} />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent" />
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${product.iconBg}`}>
                    <i className={`${product.icon} text-xl ${product.iconColor}`} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                      {product.name}
                    </h3>
                    <p className="text-sm text-white/40 font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>
                      {product.tagline}
                    </p>
                  </div>
                </div>

                <p className="text-sm md:text-base text-white/60 leading-relaxed mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {product.description}
                </p>

                {/* Highlights */}
                <ul className="flex flex-col gap-2">
                  {product.highlights.map((h) => (
                    <li key={h} className="flex items-center gap-2 text-sm text-white/50" style={{ fontFamily: "'Inter', sans-serif" }}>
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-emerald-400 text-sm" />
                      </div>
                      {h}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
